import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Layout, Button, message, Checkbox } from 'antd';
import { API_URL, LoadOptListResponse, LoadOptListResult, OPTinsData, UpdateOptResponse, UpdateOptResult } from "../constant";
import { ImportOutlined } from '@ant-design/icons';
import { api_uploadOPTcsv } from '../api/uploadExcel';
import { ColDef, GridOptions, InfiniteRowModelModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import CustomLoadingOverlay from '../components/CustomLoadingOverlay';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import { api_updateOpt, LoadOptList } from '../api/loadOPTList';
import { on } from 'events';


ModuleRegistry.registerModules([
    InfiniteRowModelModule
]);

const HeaderStyle: React.CSSProperties = {
    height: '50px',
};

export function isLoadOptListResponse(result: LoadOptListResult): result is LoadOptListResponse {
    return result.success === true; 
}

export function isUpdateOptResult(result: UpdateOptResult): result is UpdateOptResponse {
    return result.success === true; 
}

const OPTinsImport: React.FC = () => {

    const [loading, setLoading] = useState(false)
    const [rowData, setRowData] = useState<OPTinsData[]>([]);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const gridRef = useRef<AgGridReact>(null);
    const [searchword, setSearchWord] = useState<string>("")
    const [isChecked, setIsChecked] = useState(false);
    const pageSize = 100; // Define page size for infinite scrolling
    const [mode, setMode] = useState<'infinite' | 'client'>('infinite');

    const isRevertingRef = useRef(false);

    const [colDefs, setColDefs] = useState<ColDef[]>([
        // {
        //     headerName: 'ImportDate', field: "ImportDate", width: 120, resizable: true,
        //     valueFormatter: (params) => {
        //         const value = params.value;
        //         return value ? moment(value).format('MM/DD/YYYY') : '';
        //     },
        // },
        {
            headerName: 'DateOfPayment', field: "DateOfPayment", width: 120, resizable: true,
            valueFormatter: (params) => {
                const value = params.value;
                return value ? moment(value).format('MM/DD/YYYY') : '';
            },
        },
        { headerName: 'EntityName', field: "EntityName", width: 250, resizable: true },
        // { headerName: 'NAICCode', field: "NAICCode", width: 90, resizable: true },
        // { headerName: 'EntityType', field: "EntityType", width: 250, resizable: true },
        { headerName: 'FEIN', field: "FEIN", width: 120, resizable: true, cellStyle: { textAlign: "right" } },
        { headerName:'NPN', field: "NPN", width: 120, resizable: true, cellStyle: { textAlign: "right" }, editable: true,
            // editable: (params: any) => { return params.data?.Invaild === false} 
            valueSetter: (params: any) => {
                const oldValue = params.oldValue;
                let newValue = params.newValue;

                if (newValue === "") {
                    newValue = null;
                }

                if (oldValue === newValue) return false;

                const confirmed = window.confirm(
                `Do you want to change "${oldValue?.trim()}" to "${newValue?.trim()}"?`
                );

                if (!confirmed) {
                    return false; // ❗ prevents update completely
                }

                params.data[params.colDef.field] = newValue;
                return true;
            }
        },
        { headerName:'StateID', field: "StateID", width: 120, resizable: true, cellStyle: { textAlign: "right" }, editable: true,
            // editable: (params: any) => { return params.data?.Invaild === false} 
            valueSetter: (params: any) => {
                const oldValue = params.oldValue;
                let newValue = params.newValue;

                if (newValue === "") {
                    newValue = null;
                }

                if (oldValue === newValue) return false;

                const confirmed = window.confirm(
                `Do you want to change "${oldValue?.trim()}" to "${newValue?.trim()}"?`
                );

                if (!confirmed) {
                    return false; // ❗ prevents update completely
                }

                params.data[params.colDef.field] = newValue;
                return true;
            }
        },
        { headerName:'SubmitterName', field: "SubmitterName", width: 180, resizable: true, cellStyle: { textAlign: "right" }},
        // { headerName:'FilingTrackingNumber', field: "FilingTrackingNumber", width: 160, resizable: true, cellStyle: { textAlign: "right" }},
        { headerName:'FilingPeriod', field: "FilingPeriod", width: 180, resizable: true, cellStyle: { textAlign: "right" }},
        { headerName:'FilingYear', field: "FilingYear", width: 100, resizable: true, cellStyle: { textAlign: "right" }},
        // {
        //     headerName: 'SLTD', field: "SLTD", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_92', field: "PayCode_92", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_42', field: "PayCode_42", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_03', field: "PayCode_03", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_49', field: "PayCode_49", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_26', field: "PayCode_26", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_Q1', field: "PayCode_Q1", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_Q2', field: "PayCode_Q2", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_Q3', field: "PayCode_Q3", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_Q4', field: "PayCode_Q4", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_SLT91', field: "PayCode_SLT91", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_SLT', field: "PayCode_SLT", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_30', field: "PayCode_30", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_SDTRD', field: "PayCode_SDTRD", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_Refund92', field: "PayCode_Refund92", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_Refund03', field: "PayCode_Refund03", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_Refund42', field: "PayCode_Refund42", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        // {
        //     headerName: 'PayCode_Refund49', field: "PayCode_Refund49", width: 80, resizable: true, cellStyle: { textAlign: "right" },
        //     valueFormatter: (params: any) => {
        //         const v = params.value;

        //         if (v === null || v === undefined || Number.isNaN(v)) {
        //             return '';
        //         }

        //         const num = Number(v);
        //         return Number.isNaN(num) ? '' : num.toFixed(2);
        //     },
        // },
        {
            headerName: 'Amount', field: "Amount", width: 150, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        {
            headerName: 'AdditionalPayments', field: "AdditionalPayments", width: 160, resizable: true, cellStyle: { textAlign: "right" },
            valueFormatter: (params: any) => {
                const v = params.value;

                if (v === null || v === undefined || Number.isNaN(v)) {
                    return '';
                }

                const num = Number(v);
                return Number.isNaN(num) ? '' : num.toFixed(2);
            },
        },
        { headerName:'TransactionNumber', field: "TransactionNumber", width: 140, resizable: true, cellStyle: { textAlign: "right" }},
        // { headerName:'TransactionType', field: "TransactionType", width: 80, resizable: true, cellStyle: { textAlign: "right" }},
        // { headerName:'TransactionDetail', field: "TransactionDetail", width: 80, resizable: true, cellStyle: { textAlign: "right" }},
        { headerName:'TransactionStatus', field: "TransactionStatus", width: 140, resizable: true, cellStyle: { textAlign: "right" }},
        // { headerName:'StateIDFound', field: "StateIDFound", width: 80, resizable: true, cellStyle: { textAlign: "right" }},
        // { headerName:'Notes', field: "Notes", width: 300, resizable: true, cellStyle: { textAlign: "right" }},
    ]);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchWord(e.target.value)
    }

    const defaultColDef = useMemo<ColDef>(() => {
        return {
            headerClass: 'custom-header',
            sortable: false,
        };
    }, []);

    const myTheme = themeQuartz
        .withParams({
            headerColumnBorder: { color: 'gray' },
            headerColumnBorderHeight: '90%',
        });

    const onCellValueChanged = (params: any) => {
        console.log(`call onCellValueChanged: ${params.oldValue} ${params.colDef.field}`)

        const updateRow = params.data;

        api_updateOpt(updateRow)
        .then((response) => {
            if (response.success) {
            if (isUpdateOptResult(response)) {
                const rowNode = gridRef.current!.api.getDisplayedRowAtIndex(params.rowIndex)
                rowNode?.setData(response.newOpt)
            }
            }
            else {
                if ("errorMsg" in response) {
                    message.error(response.errorMsg)
                }
            }
        })
        .catch((error) => {
            console.error("An error occurred:", error.message);
            return
        });
    };

    const onCellDoubleClicked = (params: any) => {

    };

    const isValidate = (data: any) => {
        return true
    }
  
  const handleImportCSV = async () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = ''
      fileInputRef.current.click(); // Trigger file input click
    }
  };
  
  const handleUploadError = (error: unknown): void => {
    console.error('Error:', error instanceof Error ? error.message : error);
    message.error({ content: 'Failed to upload.', key: 'uploadCSV', duration: 2 });
  };

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('overwrite', 'false');

    try {
      message.loading({ content: 'Uploading...', key: 'uploadCSV', duration: 0 });
      const response = await api_uploadOPTcsv(formData);

      if (response.success) {
        message.success({ content: 'Upload successful!', key: 'uploadCSV', duration: 2 });
        setMode('infinite');
        setRowData([]);
        gridRef.current!.api.purgeInfiniteCache();
        gridRef.current!.api.ensureIndexVisible(0);
        gridRef.current!.api.refreshInfiniteCache();
      } else {
        message.error({ content: `Upload failed: ${response.errorMsg}`, key: 'uploadCSV', duration: 4 });
      }
      
    } catch (error) {
        handleUploadError(error);
    }
  };

    const infiniteGridOptions: GridOptions = {
        rowModelType: 'infinite',
        cacheBlockSize: pageSize,
        datasource: {
            getRows: async (params: any) => {
                console.log(`Requesting rows ${params.startRow} to ${params.endRow}`);
                setLoading(true);
                const page = Math.floor(params.startRow / pageSize) + 1;
                const limit = pageSize;
                try {
                    const result = await LoadOptList(searchword, isChecked, page, limit);
                    if (result.success && isLoadOptListResponse(result)) {
                        const rows = result.optlist;
                        const lastRow = rows.length < limit ? params.startRow + rows.length : -1;
                        params.successCallback(rows, lastRow);
                    } else {
                        params.failCallback();
                        message.error({ content: 'Failed to load OPT list', key: 'historyStatus', duration: 2 });
                        if ("errorMsg" in result) {
                            message.error(result.errorMsg);
                        }
                    }
                } catch (error) {
                    params.failCallback();
                    console.error('Error:', error instanceof Error ? error.message : error);
                } finally {
                    setLoading(false);
                }
            }
        },
        rowClassRules: {
            'row-red': params => params.data?.Invaild === false
        }
    };

    const clientGridOptions: GridOptions = {
        rowModelType: 'clientSide',
        rowClassRules: {
            'row-red': params => params.data?.Invaild === false
        }
    };

    const handleSearchClick = () => {
        
        if (searchword.trim() === "" && mode === 'infinite') {
            alert("Please input search word")
            return; // No action needed if search word is empty and already in infinite mode
        }

        if (searchword.trim() === "") {
            setMode('infinite');
            setRowData([]);
            gridRef.current!.api.purgeInfiniteCache();
            gridRef.current!.api.ensureIndexVisible(0);
            gridRef.current!.api.refreshInfiniteCache();
        }
        else{
            setMode('client');
            setLoading(true);
            LoadOptList(searchword, isChecked)
            .then((optResult) => {
                if (optResult.success) {
                    if (isLoadOptListResponse(optResult)) {
                        setRowData(optResult.optlist);
                    }
                } else {
                    message.error({ content: 'Failed to load the OPT list', key: 'historyStatus', duration: 2 });
                    if ("errorMsg" in optResult) {
                        message.error(optResult.errorMsg);
                    }
                }
            })
            .catch((error) => {
                console.error("An error occurred:", error.message);
            })
            .finally(() => {
                setLoading(false);
            });
        }
    }

const handleCheckboxChange = (e: any) => {
    const isOnlyRed = e.target.checked
    setIsChecked(isOnlyRed);
    if (isOnlyRed) {
        setMode('client');
        setLoading(true);
        LoadOptList(searchword, isOnlyRed)
        .then((optResult) => {
            if (optResult.success) {
                if (isLoadOptListResponse(optResult)) {
                    setRowData(optResult.optlist);
                }
            } else {
                message.error({ content: 'Failed to load the OPT list', key: 'historyStatus', duration: 2 });
                if ("errorMsg" in optResult) {
                    message.error(optResult.errorMsg);
                }
            }
        })
        .catch((error) => {
            console.error("An error occurred:", error.message);
        })
        .finally(() => {
            setLoading(false);
        });
    } else {
        setMode('infinite');
        setRowData([]);
        gridRef.current!.api.purgeInfiniteCache();
        gridRef.current!.api.ensureIndexVisible(0);
        gridRef.current!.api.refreshInfiniteCache();
    }
  };

  return (
    <div style={{ height: '100%' }} className='text-style'>
        <div className="flex items-center bg-gray-100" style={HeaderStyle}>
            <div className='ml-10 '><span>Search : &nbsp;</span></div>
            <div>
                <input type="text" className='mt-1 register-input-style' onChange={handleSearchChange}></input>
                <Button size='small' type='primary' className='ml-2 button-style' onClick={handleSearchClick}>Search</Button>
            </div>
            <div className='flex ml-2 mt-1'>
                <Button
                    variant="outlined"
                    type='primary'
                    onClick={handleImportCSV}
                    icon={<ImportOutlined className='icon-style' />}
                    className={`button-style`}>
                    ImportCSV
                </Button>
                <input
                    ref={fileInputRef}
                    type="file"
                    accept=".csv"
                    style={{ display: 'none' }} // Hide the file input
                    onChange={handleFileChange}
                />
            </div>
            <div className='flex flex-row ml-10 text-xs'>
                <div><span>The red-highlighted rows have an incorrect License Number.</span></div>
            </div>
            <Checkbox checked={isChecked} onChange={handleCheckboxChange} className='mt-1 ml-10'>
                Show only red lines
            </Checkbox>
            
        </div>
        <div className="ag-theme-alpine  tab-container">
            <AgGridReact
                key={mode}
                ref={gridRef}
                rowData={mode === 'client' ? rowData : undefined}
                gridOptions={mode === 'infinite' ? infiniteGridOptions : clientGridOptions}
                columnDefs={colDefs}
                theme={myTheme}
                defaultColDef={defaultColDef}
                headerHeight={35}
                rowHeight={25}
                onCellValueChanged={onCellValueChanged}
                onCellDoubleClicked={onCellDoubleClicked}
                loading={loading}
                loadingOverlayComponent={CustomLoadingOverlay}
                loadingOverlayComponentParams={{ message: 'Loading...' }}

            />
        </div>
    </div>
  );
};

export default OPTinsImport;
